import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { isEqual } from 'lodash'
// import { Link } from 'react-router'

// Elements
import Check from '../../../shared/elements/check'
import Icon from '../../../shared/elements/icon'
import Inline from '../../../shared/elements/inline'

import { OrderAssessmentIcons } from '../../../shared/elements/icons'

// Styles
import './selectableline.scss'

// Utils
import { translation } from '../../../utils/helpers'

class SelectableLine extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showEuro: this.props.showEuro === undefined || this.props.showEuro
    }
  }

  componentDidMount () {
  }

  componentWillReceiveProps (nextProps) {
  }

  onChange (event) {
    this.props.onChange(event)
  }

  render () {
    let showEuro = this.props.showEuro === undefined || this.props.showEuro

    // let extraCSS = 'SelectableLineStaticHeight'
    // if (this.props.extraCSS !== undefined) {
    //   extraCSS = this.props.extraCSS
    // }

    return (
      <Inline fillChildNum={[2]} block alignChildren='center'>
        {showEuro && <span className='hint--bottom-right' aria-label={translation('14998')}><Icon icon={OrderAssessmentIcons.Total_Price} /></span>}
        <Check simple name={this.props.name} onChange={this.onChange.bind(this)} checked={this.props.checked} />
        {this.props.children}
      </Inline>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(SelectableLine)



// WEBPACK FOOTER //
// ./src/app/pages/EvaluationHistory/SelectableLine/index.js